import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";

import { TableComponent } from "../../Partials/Table/TableComponent";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { TabsComponent } from "./TabsComponent";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { ActivityTemplateInterface } from "../../../Entity/Entities/Activity/ActivityTemplateInterface";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Select from "../../Partials/Material/Select";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";

class Activities extends Component {
  protected paginatorPath: string = !!this.props.app.activitiesFilterSearchState ?
                                    `Activities_${this.props.app.activitiesFilterState}_${this.props.app.activitiesFilterSearchState}` :
                                    `Activities_${this.props.app.activitiesFilterState}`;
  protected userId: number = this.props.app.session.user.id;

  public state = {
    postProcessMessage: "",
    isDeleteActivityPopupOpen: false,
    currentActivity: null,
    activities: [],
    openActivities: [],
    activitiesCount: 0,
    openActivitiesCount: 0,
    filter: this.props.app.activitiesFilterState,
    isSaving: false,
    anchorEl: null,
    isFetching: true,
    filterValue: this.props.app.activitiesFilterSearchState,
    isCreateActivityPopupOpen: false,
    selectedUnitForActivity: null,
    selectedActivityTemplateId: !!this.props.app.activityTemplates
      .filter((activityTemplate: ActivityTemplateInterface) => !activityTemplate.removed)[0] && String(this.props.app.activityTemplates
        .filter((activityTemplate: ActivityTemplateInterface) => !activityTemplate.removed)[0].id),
    selectedUnitForActivityIsNotValid: false,
    nextPath: ""
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    // if user was on dashboard/activities then go to settings and switch off isActivitiesShown
    // we should not show him dashboard/activities when he go back after settings
    if (!this.props.app?.settings?.agency?.isActivitiesShown) {
      this.props.dispatch({
        type: Constants.PAGE_DASHBOARD_UPDATE_SWITCH_TAB,
        payload: {
          index: 0
        }
      });

      return this.setState({
        nextPath: "app/dashboard/overview"
      }, this.redirectBack)
    }

    this.fetchFirstOpenActivities();
    this.fetchFirstAllActivities();
  }

  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public fetchFirstAllActivities = () => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      offset: 0,
      limit: paginationAmount,
      filterValue: this.state.filterValue,
      eventTypeId: 34,
      removed: 0,
      isSnoozed: 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        activities: data.events,
        activitiesCount: data.count,
        isFetching: false
      })
    });
  }

  public fetchFirstOpenActivities = () => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      offset: 0,
      limit: paginationAmount,
      filterValue: this.state.filterValue,
      eventTypeId: 34,
      removed: 0,
      reacted: 0,
      isSnoozed: 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        openActivities: data.events,
        openActivitiesCount: data.count,
        isFetching: false
      })
    });
  }

  public fetchFilterAllActivities = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        filterValue: this.state.filterValue,
        eventTypeId: 34,
        removed: 0,
        isSnoozed: 0
      },
      onSuccess: data => {
        this.setState({
          activities: data.events,
          activitiesCount: data.count,
          isFetching: false
        })
      }
    })
  }

  public fetchFilterOpenActivities = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        filterValue: this.state.filterValue,
        eventTypeId: 34,
        removed: 0,
        reacted: 0,
        isSnoozed: 0
      },
      onSuccess: data => {
        this.setState({
          openActivities: data.events,
          openActivitiesCount: data.count,
          isFetching: false
        })
      }
    })
  }

  public clearFilterAllActivities = () => {
    this.props.dispatch({
      type: Constants.ACTIVITIES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstAllActivities);
  }

  public clearFilterOpenActivities = () => {
    this.props.dispatch({
      type: Constants.ACTIVITIES_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstOpenActivities);
  }

  protected onEnter = (event): any => {
    if (event.key === "Enter") {
      this.paginatorPath = !!this.state.filterValue ?
                              `Activities_${this.state.filter}_${this.state.filterValue}` :
                              `Activities_${this.state.filter}`;

      this.props.dispatch({
        type: Constants.ACTIVITIES_FILTER_SEARCH_UPDATE_STATE,
        payload: {
          filter: this.state.filterValue
        }
      });

      if (this.state.filter === "all") {
        this.fetchFirstAllActivities();
      } else {
        this.fetchFirstOpenActivities();
      }
    }
  }

  public setFilterValue = (event): any => {
    this.setState({
      filterValue: event.target.value
    } ,() => {
      if (this.state.filterValue === "") {
        if (this.state.filter === "all") {
          this.clearFilterAllActivities();
        } else {
          this.clearFilterOpenActivities();
        }
      }
    });
  }

  public fetchActivities = () => {
    if (this.state.filter === "all") {
      const payload: any = {
        offset: !!this.state.activities ?  this.state.activities.length : 0,
        limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        eventTypeId: 34,
        removed: 0,
        isSnoozed: 0
      };

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const activitiesArr: EventInterface[] = !!this.state.activities ?
                                                  [...this.state.activities, ...data.events] : [...data.events];

          this.setState({
            activities: activitiesArr,
            activitiesCount: data.count,
            isFetching: false
          });
        }
      });
    } else if (this.state.filter === "open") {
      const payload: any = {
        offset: !!this.state.openActivities ?  this.state.openActivities.length : 0,
        limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        eventTypeId: 34,
        removed: 0,
        reacted: 0,
        isSnoozed: 0
      };

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const openActivitiesArr: EventInterface[] = !!this.state.openActivities ?
                                          [...this.state.openActivities, ...data.events] : [...data.events];

          this.setState({
            openActivities: openActivitiesArr,
            openActivitiesCount: data.count,
            isFetching: false
          });
        }
      });
    }
  }

  public changeFilter = (event: any): void => {
    const filter: string = event.target.value;

    this.setState({
      filter: filter
    }, () => {
      this.paginatorPath = `Activities_${filter}`;

      this.props.dispatch({
        type: Constants.ACTIVITIES_FILTER_UPDATE_STATE,
        payload: {
          filter: filter
        }
      });

      if (filter === "all") {
        if (this.state.filterValue) {
          this.fetchFilterAllActivities();
        } else {
          this.fetchFirstAllActivities();
        }
      } else if (filter === "open") {
        if (this.state.filterValue) {
          this.fetchFilterOpenActivities();
        } else {
          this.fetchFirstOpenActivities();
        }
      }
    });
  }

  public getAmountsOfFilteredActivities = (filter: string): number => {
    switch (filter) {
      case "all":
        return this.state.activitiesCount;
      case "open":
        return this.state.openActivitiesCount;
      default:
        return;
    }
  }

  public getFilteredActivities = (filter: string): EventInterface[] => {
    switch (filter) {
      case "all":
        return this.state.activities;

      case "open":
        return this.state.openActivities;
      default:
        return;
    }
  }

  public deleteActivity = (activity: EventInterface) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: activity
      },
      onSuccess: () => {
        this.fetchFirstAllActivities();
        this.fetchFirstOpenActivities();
      }
    });
  }

  protected openMenu = (event: any, activity: EventInterface): void => {
    this.setState({
      currentActivity: activity,
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public changeActivityStatus = () => {
    let selectedEntityForActivity;
    const activity: any = {
      eventTypeId: 34,
      reacted: !this.state.currentActivity.reacted,
      reporterId: this.state.currentActivity.reporterId,
      content: {
        name: this.state.currentActivity.content && this.state.currentActivity.content.name,
        subject: this.state.currentActivity.content && this.state.currentActivity.content.subject,
        description: this.state.currentActivity.content && this.state.currentActivity.content.description
      },
      amazonFolderName: this.state.currentActivity.amazonFolderName,
      id: this.state.currentActivity && this.state.currentActivity.id
    }
    if (!!this.state.currentActivity && this.state.currentActivity.property) {
      selectedEntityForActivity = this.state.currentActivity.property;
    }


    if (!!this.state.currentActivity && this.state.currentActivity.unit) {
      selectedEntityForActivity = this.state.currentActivity.unit;
    }

    if (selectedEntityForActivity instanceof Property) {
      activity.propertyId = selectedEntityForActivity.id;
    }

    if (selectedEntityForActivity instanceof Unit) {
      activity.unitId = selectedEntityForActivity.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...activity
        },
        onSuccess: () => {
          this.setState({
            anchorEl: null,
            isSaving: false,
          },() => {
            this.fetchFirstAllActivities();
            this.fetchFirstOpenActivities();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false,
          });
        }
      });
    });
  }

  public getActivities = () => {
    return this.getFilteredActivities(this.state.filter)
      .map((activity: EventInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => this.redirect(`/app/activity/update/${activity.id}`)}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "0px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  className="icon icon-ic-activity"
                  style={{
                    color: activity.reacted ? "" : "#00BCD4"
                  }}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{width: "15%"}}>{activity.createdAt && this.formatter.formatDate(new Date(activity.createdAt))}</TableCell>
            <TableCell style={{width: "20%"}}>{(activity.content && activity.content.name) || activity.subject}</TableCell>
            <TableCell style={{width: "30%"}}>{activity.object && activity.object.listDisplayName}</TableCell>
            <TableCell style={{width: "15%"}}>{`${activity.countOfClosedTasks}/${activity.countOfTasks}`}</TableCell>
            <TableCell style={{width: "10%"}}>{activity.status}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, activity)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.state.currentActivity && this.state.currentActivity.id === activity.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.redirect(`/app/activity/update/${activity.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={this.changeActivityStatus}
                  >
                    <ListItemIcon><div className={`icon icon-ic-${this.state.currentActivity && this.state.currentActivity.reacted ? "reopen" : "close" } aligned`}></div></ListItemIcon>
                    <ListItemText>{this.state.currentActivity && this.state.currentActivity.reacted ? this.trans("menu/status-option/open") : this.trans("menu/status-option/close")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.setState({isDeleteActivityPopupOpen: true, anchorEl: null})}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public selectUnitForActivity = (unit: UnitInterface): void => {
    this.setState({
      selectedUnitForActivityManuallyChanged: true,
      selectedUnitForActivity: unit,
      hasModifiedData: true,
      selectedUnitForActivityIsNotValid: false
    });
  }

  public clearUnitForActivity = (): void => {
    this.setState({
      selectedUnitForActivity: null,
      hasModifiedData: true,
      selectedUnitForActivityIsNotValid: false
    });
  }

  public changeActivityTemplate = (event): void => {
    const activityTemplateId: number = event.target.value;

    this.setState({
      selectedActivityTemplateId: String(activityTemplateId)
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={7}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "48px",
                  maxHeight: "48px"
                }}
              >
                <h3 className="card-title">
                  {this.trans("page/dashboard-tab/activities")}
                </h3>
                <div className="button-container">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length === 0) {
                        this.props.dispatch({
                          type: Constants.SNACKBAR_ADD_MESSAGE,
                          payload: {
                            message: `${this.trans("page/dashboard-tab/activities-dialog/noactivitytemplates-1")} ${this.trans("page/dashboard-tab/activities-dialog/noactivitytemplates-2")}`,
                            type: "warning"
                          }
                        });
                      } else {
                        this.setState({
                          isCreateActivityPopupOpen: true
                        });
                      }
                    }}
                  >
                    {this.trans("new-activity")}
                  </Button>
                </div>
              </div>

              <div>
                <div>
                  <div
                    className="list-filters-wrapper"
                  >
                    <div style={{display: "flex"}}>
                      <RadioGroup
                        name="activitiesFilters"
                        value={this.state.filter}
                        onChange={this.changeFilter}
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <FormControlLabel
                          value="open"
                          control={<Radio color="primary" />}
                          label={
                            (<span>{this.trans("status-open")}</span>)}
                        />
                        <FormControlLabel
                          value="all"
                          control={<Radio color="primary" />}
                          label={
                            (<span>{this.trans("all")}</span>)}
                        />
                      </RadioGroup>
                    </div>
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table tasks-listing-table with-first-border"
                  headers={[
                    "", this.trans("date"), this.trans("subject"), this.trans("unit"), this.trans("page/dashboard-tab/activities-section/tableofactivities-label/closedtasks"), this.trans("status"), ""
                  ]}
                  rows={this.getActivities()}
                  rowsLength={this.getAmountsOfFilteredActivities(this.state.filter)}
                  subtitle={this.trans("title-no-activities-to-list")}
                  fetch={this.fetchActivities}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-activity")}
          content={this.trans("you-are-about-to-delete-activity", {name: this.state.currentActivity && this.state.currentActivity.name ? this.state.currentActivity.name : ""})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteActivityPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteActivityPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteActivityPopupOpen: false }); this.deleteActivity(this.state.currentActivity) }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("new-activity")}
          content={
            <div>
              <div className="search-bar-container">
                <Searchbar
                  {...this.props}
                  id="selectedUnitForActivity"
                  floatingLabelText={this.trans("dropdown/activity-field/object-label")}
                  allResults={true}
                  objectField={true}
                  onChange={this.selectUnitForActivity}
                  onClear={this.clearUnitForActivity}
                  searchParameter={"objectForActivitySearch"}
                  selectedEntity={this.state.selectedUnitForActivity}
                  error={this.state.selectedUnitForActivityIsNotValid && this.trans("be_ajv_not_validated")}
                  styleInModal={"pick-object-modal"}
                  searchText={this.state.selectedUnitForActivity ? `${this.state.selectedUnitForActivity.nameOfEntity}, ${this.state.selectedUnitForActivity.displayName}` : null}
                />
              </div>

              <Select
                className="form-element full-size form-input"
                variant="standard"
                htmlFor="activityTemplate"
                label={this.trans("activity-template")}
                value={String(this.state.selectedActivityTemplateId)}
                onChange={this.changeActivityTemplate}
                name="activityTemplate"
                id="activityTemplate"
                error={this.getErrorFor("activityTemplate")}
              >
                {
                  this.props.app.activityTemplates
                    .filter((activityTemplate: ActivityTemplateInterface) => !activityTemplate.removed)
                    .map((activityTemplate: ActivityTemplateInterface, key: number) => {
                      return (
                        <MenuItem
                          key={`activityTemplate-${key}`}
                          value={activityTemplate.id}
                        >
                          {`${activityTemplate.name}`}
                        </MenuItem>
                      );
                    })
                  }
              </Select>
            </div>
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-create")}
          openLeavePrompt={this.state.isCreateActivityPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              isCreateActivityPopupOpen: false,
              selectedUnitForActivity: null,
              selectedActivityTemplateId: !!this.props.app.activityTemplates
                .filter((activityTemplate: ActivityTemplateInterface) => !activityTemplate.removed)[0] && String(this.props.app.activityTemplates
                  .filter((activityTemplate: ActivityTemplateInterface) => !activityTemplate.removed)[0].id),
              selectedUnitForActivityIsNotValid: false
            });
          }}
          onSave={() => {
            if (!this.state.selectedUnitForActivity) {
              return this.setState({
                selectedUnitForActivityIsNotValid: true
              })
            }

            this.props.dispatch({
              type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
              payload: {
                unitId: this.state.selectedUnitForActivity && this.state.selectedUnitForActivity.id
              }
            });

            this.redirect(`/app/activity/create/${this.state.selectedActivityTemplateId}/0/${this.state.selectedUnitForActivity && this.state.selectedUnitForActivity.id}`);
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    units: state.units,
    component: state.activities,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(Activities);
